import React, { useRef } from "react";
import MainLayout from "../layout/main-layout";
import UiUxHeadSection from "../Components/UI-UX/ui-ux-head-section";
import UiUxBenefits from "../Components/UI-UX/ui-ux-benefits";
import UiUxDesignProcess from "../Components/UI-UX/ui-ux-design-process";
import WhyChooseUiUx from "../Components/UI-UX/why-choose-us-ui-ux";
import UiUxContact from "../Components/UI-UX/ui-ux-contact";

function UiUxDesign() {
   const contactRef = useRef<HTMLDivElement>(null);
  
    const handleScrollToContact = () => {
      contactRef.current?.scrollIntoView({ behavior: "smooth" });
    };
  return (
    <div>
      <MainLayout>
        <UiUxHeadSection onScroll={handleScrollToContact} />
        <UiUxBenefits />
        <UiUxDesignProcess />
        <WhyChooseUiUx />
        <UiUxContact contactRef={contactRef} />
      </MainLayout>
    </div>
  );
}

export default UiUxDesign;
